import { HisSearchResultRow, HisBaseGlobalsService, HisUiService } from 'hisng';
import { PsvPersonProfile } from 'app/cs/psv/common/model/person/psvPersonProfile';
import { PersonDetailViewSearchResultComponent } from '../person-detail-view-search-result.component';

export interface RowLabels {
    title: string;
    // eslint-disable-next-line @typescript-eslint/member-ordering
    [key: string]: string;
}

export abstract class AbstractDetailViewListEntry {

    protected hisBaseGlobalsService: HisBaseGlobalsService;
    protected hisUiService: HisUiService;
    protected person: PsvPersonProfile;
    protected personDetailViewSearchResultComponent: PersonDetailViewSearchResultComponent;

    abstract rowLabels: RowLabels;

    constructor(
        hisBaseGlobalsService: HisBaseGlobalsService,
        hisUiService: HisUiService,
        person: PsvPersonProfile,
        personDetailViewSearchResultComponent: PersonDetailViewSearchResultComponent) {

        this.hisBaseGlobalsService = hisBaseGlobalsService;
        this.hisUiService = hisUiService;
        this.person = person;
        this.personDetailViewSearchResultComponent = personDetailViewSearchResultComponent;
    }


    abstract getOverSearchResultLink(): SimpleLinkDefinition;
    abstract getSubheading(row: HisSearchResultRow, data: any, index: number): string;
    abstract getHeaderLine(row: HisSearchResultRow): string;
    abstract getTitleLine(row: HisSearchResultRow): string;
    abstract getToolTip(row: HisSearchResultRow): string;
    abstract getTitleLink(row: HisSearchResultRow): string;
    abstract getExtendableLine(row: HisSearchResultRow, i: number, first: number, rowsPerPage: number): string;
    abstract getExtendableLineSecond(row: HisSearchResultRow, i: number, first: number, rowsPerPage: number): string;
    abstract isExtendable(row: HisSearchResultRow): boolean;
    abstract isExtendableSecond(row: HisSearchResultRow): boolean;
    abstract getFooterLine(row: HisSearchResultRow): string;
}

export class SimpleLinkDefinition {
    text: string;
    icon: string;
    target: string;

    constructor(text: string, target: string, icon: string) {
        this.text = text;
        this.target = target;
        this.icon = icon;
    }
}
